export default __webpack_public_path__ + "static/media/github.b2c4cedf.svg";